export default function clampSpreadIndex(spreadIndex: number, spreadCount: number | undefined): number {
  const count = spreadCount ?? 1;
  return Math.max(0, Math.min(spreadIndex, count - 1));
}
